import type { Permissions } from '../../../model/config/permissions/types';

export const FETCH_PERMISSIONS_SUCCESS =
	'state.actions.permissions.FETCH_PERMISSIONS_SUCCESS' as const;

export type FetchPermissionsSuccessAction = {
	type: typeof FETCH_PERMISSIONS_SUCCESS;
	payload: {
		permissions: Permissions;
	};
};

export const fetchPermissionsSuccess = (
	permissions: Permissions,
): FetchPermissionsSuccessAction => ({
	type: FETCH_PERMISSIONS_SUCCESS,
	payload: {
		permissions,
	},
});

export const FETCH_PERMISSIONS_FAILURE =
	'state.actions.permissions.FETCH_PERMISSIONS_FAILURE' as const;

export type FetchPermissionsFailureAction = {
	type: typeof FETCH_PERMISSIONS_FAILURE;
};

export const fetchPermissionsFailure = (): FetchPermissionsFailureAction => ({
	type: FETCH_PERMISSIONS_FAILURE,
});

export type Action = FetchPermissionsSuccessAction | FetchPermissionsFailureAction;
